import { Injectable } from '@angular/core';
import * as _ from 'underscore';
import {
  MatLegacySnackBar as MatSnackBar,
  MatLegacySnackBarHorizontalPosition as MatSnackBarHorizontalPosition,
  MatLegacySnackBarVerticalPosition as MatSnackBarVerticalPosition,
} from '@angular/material/legacy-snack-bar';
import { MainService } from '../delavci/main.service';
import { HelpdeskService } from '../delavci/helpdesk.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HelpersService {


  private hostnameSource = new BehaviorSubject<string>(JSON.parse(localStorage.getItem('hostname')));
  public currentHostname = this.hostnameSource.asObservable();
  private hasMessageSource = new BehaviorSubject<boolean>(false);
  public hasMessage$ = this.hasMessageSource.asObservable();
  private messageSource = new BehaviorSubject<number>(0);
  public message = this.messageSource.asObservable();
  constructor(private _snackBar: MatSnackBar) {

  }

  changeHostname(newHostname) {
    localStorage.setItem('hostname', JSON.stringify(newHostname));
    this.hostnameSource.next(newHostname);
  }

  doGraphSorter(labels, values) {
    let joinedArray = [];
    for (let i = 0; i < labels.length; i++) {
      joinedArray.push({ label: labels[i], value: values[i] });
    }
    let outArray = [];
    outArray = _.sortBy(joinedArray, 'value');
    outArray.reverse();

    return outArray;
  }

  dateParserFromDayToMin(date) {
    if (date) {
      let year, month, day, h, min, sec;
      /*2020-01-17 15:31:07.0*/
      year = date.substring(0, 4);
      month = date.substring(5, 7);
      day = date.substring(8, 10);
      h = date.substring(11, 13);
      min = date.substring(14, 16);
      sec = date.substring(17, 19);
      date = day + "." + month + "." + year + " " + h + ":" + min;
      return date;
    }

  }

  dateParserFromDayToYear(date) {
    if (date) {
      let year, month, day, h, min, sec;
      year = date.substring(0, 4);
      month = date.substring(5, 7);
      day = date.substring(8, 10);
      date = day + "." + month + "." + year;
      return date;
    }
  }

  statusTooltip(colorId) {
    if (colorId === 1) {
      return "Odprto";
    } else if (colorId === 3) { // id = 26  3
      return "Potrjeno";
    } else if (colorId === 6) { //id = 29
      return "Preklicano"
    } else if (colorId === 7) { // id = 7
      return "TO-DO"
    } else if (colorId === 35) { // id = 361
      return "Se ne ureja"
    } else if (colorId === 13) { // id = 97
      return "V pripravi"
    } else if (colorId === 36) { // id = 36 385
      return "TO-DO rešeno"
    } else if (colorId === 401) {
      return "ring ring"
    } else if (colorId === 37) { // id = 37 386
      return "V pogovoru"
    } else if (colorId === 38) { // id = 38 387
      return "Neodgovorjeno"
    }
  }
  openSnackBar(message, action) {
    this._snackBar.open(message, action, {
      duration: 1000,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
    });
  }
  checkIfMessageExists(dataSource) {
    this.hasMessageSource.next(false);

    if (dataSource && dataSource.filteredData && dataSource.filteredData.length > 0) {
      dataSource.filteredData.forEach(element => {
        const unreadMessages = element.numberOfUnreadMessages || 0;

        if (unreadMessages > 0) {
          this.hasMessageSource.next(true);
          this.messageSource.next(element.id);
          return;
        }
      });
    }
  }



}
